import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class LeadSourcesService {
    // Get all
    static async getAllLeadSources() {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.LEADSOURCES; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch lead sources.');
            return [];
        }
    }

    // Create 
    static async addNewLeadSource(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.LEADSOURCES; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Lead source added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new lead source.');
        }
    }

    // Get by ID
    static async getLeadSourceById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADSOURCES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch lead source by ID');
        }
    }

    // Update 
    static async updateLeadSourceById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADSOURCES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Lead source updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update lead source.');
        }
    }

    // Delete by ID
    static async deleteLeadSource(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADSOURCES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete lead source.');
            }
        } catch (error) {
            console.error('Error deleting lead source:', error);
            throw error;
        }
    }

    // Delete multiple 
    static async deleteManyLeadSources(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADSOURCES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
